import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, Phone, MessageCircle, CheckCircle } from 'lucide-react';
import { availability, contactInfo } from '../data/mock';
import { Link } from 'react-router-dom';

const Disponibilites = () => {
  return (
    <div className="min-h-screen bg-black pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-black to-black/95">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            <span className="text-[#cbb26a]">Disponibilités</span>
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Consultez nos dates disponibles et réservez votre créneau
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          {/* Disponibilites */}
          <div className="max-w-4xl mx-auto mb-16">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {availability.map((item) => (
                <Card key={item.id} className="bg-white/5 border-[#cbb26a]/30 hover:bg-white/10 transition-all duration-300">
                  <CardHeader>
                    <CardTitle className="text-[#cbb26a] flex items-center space-x-2">
                      <Calendar size={24} />
                      <span>{item.month}</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      {item.dates.map((date, index) => (
                        <div key={index} className="flex items-center space-x-2">
                          <CheckCircle size={18} className="text-[#cbb26a] flex-shrink-0" />
                          <span className="text-white/90">{date}</span>
                        </div>
                      ))}
                    </div>
                    <div className="mt-4 pt-4 border-t border-[#cbb26a]/20">
                      <span className="inline-block px-3 py-1 bg-[#cbb26a]/20 text-[#cbb26a] rounded-full text-sm">
                        Disponible
                      </span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Informations */}
          <div className="max-w-4xl mx-auto mb-16">
            <Card className="bg-white/5 border-[#cbb26a]/30">
              <CardHeader>
                <CardTitle className="text-2xl text-white">
                  Comment <span className="text-[#cbb26a]">réserver</span> ?
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#cbb26a] text-black flex items-center justify-center font-bold">
                    1
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Contactez-nous</h4>
                    <p className="text-white/70">
                      Appelez-nous au {contactInfo.phone} ou contactez-nous via WhatsApp pour vérifier 
                      la disponibilité de votre date souhaitée.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#cbb26a] text-black flex items-center justify-center font-bold">
                    2
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Documents requis</h4>
                    <p className="text-white/70">
                      Préparez le certificat LOF de votre femelle, son carnet de vaccination et le test 
                      de brucellose (moins de 2 mois).
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#cbb26a] text-black flex items-center justify-center font-bold">
                    3
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Acompte</h4>
                    <p className="text-white/70">
                      Versez un acompte de 100€ pour confirmer votre réservation. Le solde sera à régler 
                      le jour de la première saillie.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#cbb26a] text-black flex items-center justify-center font-bold">
                    4
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Confirmation</h4>
                    <p className="text-white/70">
                      Vous recevrez une confirmation avec toutes les informations pratiques (adresse, 
                      horaires, préparation).
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Note importante */}
          <div className="max-w-4xl mx-auto mb-16">
            <Card className="bg-[#cbb26a]/10 border-[#cbb26a]/30">
              <CardContent className="p-6">
                <h3 className="text-[#cbb26a] font-semibold mb-3 text-lg">Note importante</h3>
                <p className="text-white/80">
                  Les dates affichées sont mises à jour régulièrement. Si vous ne trouvez pas de créneau 
                  correspondant à vos besoins, n'hésitez pas à nous contacter. Nous ferons notre possible 
                  pour trouver une solution adaptée.
                </p>
              </CardContent>
            </Card>
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-r from-[#cbb26a]/10 to-transparent rounded-xl p-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Réservez votre date maintenant
            </h3>
            <p className="text-white/80 mb-8 max-w-2xl mx-auto">
              Contactez-nous pour réserver votre créneau
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                size="lg"
                className="bg-[#cbb26a] text-black hover:bg-[#d4c485] transition-all duration-300"
              >
                <Link to="/contact">Formulaire de contact</Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-[#cbb26a] text-white hover:bg-[#cbb26a]/10 transition-all duration-300"
              >
                <a href={`https://wa.me/33${contactInfo.whatsapp.substring(1)}`} className="flex items-center space-x-2">
                  <MessageCircle size={20} />
                  <span>WhatsApp</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disponibilites;